import React from "react";
import { icons } from "../../assets/icons";

const CustomAccordion = ({ items, activeIndex, setActiveIndex }) => {
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderedItems = items.map((item, index) => {
    const isActive = item.isArrowEnable && index === activeIndex;

    return (
      <div key={item.title || item.id || `accordion-item-${index}`} className="flex flex-col mt-4">
        <div
          onClick={() => onItemClick(index)}
          className={`flex justify-between h-[4rem] items-center w-100 bg-[var(--whiteColor)] px-5 cursor-pointer accordion-not-active ${
            isActive ? "accordion-active" : ""
          }`}
        >
          <div
            className={
              isActive ? "text-[var(--whiteColor)]" : "text-[var(--blackColor)]"
            }
          >
            {item?.renderLeft ? item.renderLeft() : null}
          </div>
          <div className="flex items-center gap-x-8">
            {item?.renderRight && !isActive ? item.renderRight() : null}
            {item.isArrowEnable && <img
              className={`arrow ${isActive ? "rotate" : ""}`}
              src={icons.arrowDown}
              alt="arrow down icon"
            />}
          </div>
        </div>
        <div className={`accordion-content ${isActive ? "block" : "hidden"}`}>
          {item?.Component ? <item.Component /> : null}
        </div>
      </div>
    );
  });

  return <div className="accordion">{renderedItems}</div>;
};

export default CustomAccordion;
